import { Component } from '@angular/core';
import { CALL_CENTER_NUMBER, CALL_CENTER_NUMBER_HOME } from '@common/constants/business.constants';
import { OFFICES_ROUTE } from '@common/constants/routes.constants';
@Component({
  selector: 'app-help-box',
  templateUrl: './help-box.component.html',
  styleUrls: ['./help-box.component.scss'],
})
export class HelpBoxComponent {

  callCenterNumber: string;
  callCenterNumberHome: string;
  officesRoute: string;

  constructor() {
    this.callCenterNumber = CALL_CENTER_NUMBER;
    this.callCenterNumberHome = CALL_CENTER_NUMBER_HOME;
    this.officesRoute = OFFICES_ROUTE;
  }

  public clickEvent() {
    window.location.href = `tel:${this.callCenterNumber}`;
  }
}
